module.exports = __webpack_public_path__ + "static/media/Пекло.0aad84f1.png";